export default __webpack_public_path__ + "static/media/posttest-02.09615ebd.svg";